<template>
  <div class="m-chart-bars">
    <p
      v-if="!series.length"
      class="m-chart-bars-empty"
    >
      {{ emptyText }}
    </p>
    <ul
      v-else
      class="m-chart-bars-list"
    >
      <li
        v-for="item in series"
        :key="'bar-' + item.key"
        class="m-chart-bars-row"
      >
        <!--
          El nombre va ARRIBA de la barra y no al costado: los modelos tienen nombres largos y en una
          tarjeta angosta una columna de etiquetas los cortaba a la mitad.
          El valor va SIEMPRE escrito: asi el dato nunca depende del color ni de pasar el mouse.
        -->
        <span class="m-chart-bars-head">
          <span
            class="m-chart-bars-label"
            :title="item.label"
          >
            {{ item.label }}
          </span>
          <span class="m-chart-bars-value">
            {{ item.text }}
          </span>
        </span>
        <span class="m-chart-bars-track">
          <span
            class="m-chart-bars-bar"
            :style="{ backgroundColor: color, width: barWidth(item.value) }"
          ></span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
/*
 | Barras horizontales ordenadas, hechas con HTML y CSS (no hay libreria de graficos en app-sales).
 |
 | Una sola serie y por lo tanto un solo color: lo que distingue a cada fila es su nombre escrito al
 | costado, no el tono. Se usa para comparar magnitudes con nombres largos (modelos, planes, apps),
 | que en columnas verticales no entran.
 */
export default {
  name: 'MoleculeChartBars',

  props: {
    color: {
      type: String,
      default: '#2a78d6'
    },

    emptyText: {
      type: String,
      default: ''
    },

    // [{ key, label, value, text }] — text es el valor ya formateado que se escribe a la derecha
    series: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    scale () {
      const mayor = this.series.reduce((max, item) => (item.value > max ? item.value : max), 0)

      return mayor > 0 ? mayor : 1
    }
  },

  methods: {
    barWidth (valor) {
      const ancho = (Math.max(Number(valor) || 0, 0) / this.scale) * 100

      // Un valor mayor a cero nunca se dibuja invisible
      return ancho > 0 && ancho < 1.5 ? '2px' : `${ancho}%`
    }
  }
}
</script>
